/**
 * Farbpalette für Fächer/Themen (Auswahl im UI).
 *
 * Flache Liste aus 38 eigenständig benannten Farben (Rot, Blau, Türkis, …) –
 * bewusst keine systematischen Hell-/Dunkel-Abstufungen derselben Farbe.
 */

export interface NamedColor {
  name: string;
  hex: string;
}

export const NAMED_COLORS: NamedColor[] = [
  { name: "Schwarz", hex: "#18181b" },
  { name: "Anthrazit", hex: "#3f3f46" },
  { name: "Grau", hex: "#6b7280" },
  { name: "Taupe", hex: "#a8a29e" },
  { name: "Braun", hex: "#78350f" },
  { name: "Schokolade", hex: "#5c2e0e" },
  { name: "Kupfer", hex: "#b45309" },
  { name: "Bernstein", hex: "#d97706" },
  { name: "Gold", hex: "#ca8a04" },
  { name: "Gelb", hex: "#eab308" },
  { name: "Zitrone", hex: "#facc15" },
  { name: "Olive", hex: "#7a7a1a" },
  { name: "Limette", hex: "#84cc16" },
  { name: "Grün", hex: "#16a34a" },
  { name: "Smaragd", hex: "#059669" },
  { name: "Minze", hex: "#34d399" },
  { name: "Türkis", hex: "#14b8a6" },
  { name: "Petrol", hex: "#115e59" },
  { name: "Cyan", hex: "#06b6d4" },
  { name: "Himmelblau", hex: "#38bdf8" },
  { name: "Blau", hex: "#2563eb" },
  { name: "Marineblau", hex: "#1e3a8a" },
  { name: "Stahlblau", hex: "#3b6b8f" },
  { name: "Indigo", hex: "#4f46e5" },
  { name: "Violett", hex: "#7c3aed" },
  { name: "Lavendel", hex: "#a78bfa" },
  { name: "Aubergine", hex: "#581c87" },
  { name: "Magenta", hex: "#c026d3" },
  { name: "Fuchsia", hex: "#d946ef" },
  { name: "Pink", hex: "#ec4899" },
  { name: "Rosé", hex: "#fb7185" },
  { name: "Karminrot", hex: "#a3123a" },
  { name: "Bordeaux", hex: "#7f1d1d" },
  { name: "Rot", hex: "#dc2626" },
  { name: "Koralle", hex: "#f87171" },
  { name: "Orange", hex: "#ea580c" },
  { name: "Terrakotta", hex: "#c2410c" },
  { name: "Sand", hex: "#cba35c" },
];

/** Flache Liste aller Palettenfarben (Hex, lowercase). */
export const PALETTE: string[] = NAMED_COLORS.map((c) => c.hex);

export function defaultColor(): string {
  return "#2563eb"; // Blau
}

/** Prüft, ob eine Farbe Teil der Palette ist (Groß-/Kleinschreibung egal). */
export function isPaletteColor(hex: string): boolean {
  const v = hex.trim().toLowerCase();
  return PALETTE.includes(v);
}

/** Lesbare Textfarbe (schwarz/weiß) für einen Hintergrund-Hex. */
export function contrastText(hex: string): string {
  const c = hex.replace("#", "");
  if (c.length < 6) return "#fff";
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? "#1b1f24" : "#ffffff";
}
